import { useCallback, useEffect, useRef, useState } from "react";

export const useShadow = (open?: boolean) => {
  const [hasScroll, setHasScroll] = useState(false);

  const scrollRef = useRef<HTMLDivElement>(null);

  const setScroll = useCallback(
    (scroll: boolean) => {
      setHasScroll(scroll);
    },
    [setHasScroll],
  );

  useEffect(() => {
    setTimeout(() => {
      const { offsetHeight, scrollHeight } = scrollRef.current || {};
      if (scrollHeight && offsetHeight) {
        setScroll(offsetHeight < scrollHeight);
      }
    }, 100);
  }, [setScroll, open]);

  return { hasScroll, scrollRef };
};
